export default function readableContentType(contentType) {
  let contentTypeReadable;
  if (contentType === 'drill') {
    contentTypeReadable = 'practice';
  } else {
    contentTypeReadable = contentType;
  }

  return contentTypeReadable;
}



// WEBPACK FOOTER //
// ./library/js/plugins/readable-content-type.js